'use strict';

import * as queryString from 'query-string';

const $Q = Symbol('$q');
const $WINDOW = Symbol('window');
const $TIMEOUT = Symbol('$timeout');
const $INTERVAL = Symbol('$interval');
const $HTTP = Symbol('$http');
const API = Symbol('api');
const QS = Symbol('query string');
const DEVICE_DETECTOR = Symbol('deviceDetector');
const ANALYTICS_SERVICE = Symbol('analyticsService');

class SignupController {
  constructor(
    $q,
    $window,
    $timeout,
    $interval,
    apiService,
    $http,
    deviceDetector,
    downloadUrlsService,
    analyticsService
  ) {
    'ngInject';

    const md = new MobileDetect($window.navigator.userAgent);

    this[$Q] = $q;
    this[$WINDOW] = $window;
    this[$TIMEOUT] = $timeout;
    this[$INTERVAL] = $interval;
    this[API] = apiService;
    this[DEVICE_DETECTOR] = deviceDetector;
    this[$HTTP] = $http;
    this[ANALYTICS_SERVICE] = analyticsService;

    this[QS] = queryString.parse($window.location.search);

    this.isMobile = md.mobile() !== null;

    if (this[QS].token) {
      this[API].setToken(this[QS].token);
    }

    // load first template, choose download
    this.dashboardUrl = 'https://app.staff.com';

    // get available downloads
    this.downloads = downloadUrlsService;

    this.determineDownload();

    this.step2Class = 'active';
    this.step3Class = '';

    this[ANALYTICS_SERVICE].page();
  }


  startDownload(type) {
    this.step2Class = 'done';
    this.step3Class = 'active';

    const {
      companyName,
      userName,
      userEmail,
    } = this[QS];

    let userId;
    let companyId;
    let timezone;

    const updateCompany = trackingMode =>
      this[API].timezoneDetect()
        .then(res => {
          timezone = res.timeZoneId;
          return this[API].companyCreate(companyName, timezone, trackingMode);
        })
        .then((res) => {
          companyId = res.id;
          userId = res.creatorId;

          return this[ANALYTICS_SERVICE].trackEvent(
            'sign-up-create-user',
            {
              userId,
              userName,
              userEmail,
              companyId,
              companyName,
              timezone,
              trackingMode,
            }
          )
            .then(() => this[ANALYTICS_SERVICE].trackEvent(
              'sign-up-create-company',
              {
                userId,
                userName,
                userEmail,
                companyId,
                companyName,
                timezone,
                trackingMode,
              }
            ));
        });

    updateCompany(type)
      .then(() => {
        this.goToDashboard();
      });
  }

  expandBalloon() {
    this.showHelp = !this.showHelp;
    this.windowSize = this[$WINDOW].innerWidth;
    if (this.showHelp) {
      setTimeout(() => { // eslint-disable-line angular/timeout-service
        this[$WINDOW].scrollTo(0, this[$WINDOW].document.body.scrollHeight);
      }, 100);
    }
  }

  goToDashboard() {
    let url = this.dashboardUrl;

    if (this[QS].token) {
      url += `?first-login=1&token=${this[QS].token}`;

      /**
       * Intercept UTM params
       *
       * @since STAFF-4854 params are intercepted also if prefixed with '?'
       *  (it can happen if question mark is doubled: '??')
       *  and also if params are not lowercased
       */
      angular.forEach(
        this[ANALYTICS_SERVICE].getUtmParamsFromQueryString(),
        (value, name) => url += `&${name}=${value}`
      );
    }

    this[$WINDOW].location = url;
  }

  // determine download based on OS
  determineDownload() {
    this.os = this[DEVICE_DETECTOR].os;
    if (this.os !== 'windows' && this.os !== 'linux' && this.os !== 'mac') {
      this.os = 'other';
    }
    this.downloads.then(res => {
      this.download = res[this.os];
    });
  }
}

export default SignupController;
